import React from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm'
import LoadingButton from '../../components/LoadingButton'

const Filter = ({ setQuery }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()

  // Static driver list (abhi ke liye hardcoded, baad me API se aa sakti hai)
  const drivers = [
    { id: 1, name: 'Driver A' },
    { id: 2, name: 'Driver B' },
    { id: 3, name: 'Driver C' },
  ]

  const onSubmit = async (data) => {
    console.log('Form Data:', data)
    // Query params ke liye filter
    let query = {}
    if (data?.date) query.date = data.date.toString()
    if (data?.driver) query.driver = data.driver
    setQuery(query)
  }

  return (
    <>
      <div className="p-4" id="collapse-inputs">
        <Form
          className="row align-items-end"
          onSubmit={handleSubmit(onSubmit)}
          id="filter-management"
        >
          {/* Filter by Date */}
          <div className="col-lg-4">
            <Form.Group className="mb-0">
              <Form.Label>Filter by Date: </Form.Label>
              <Controller
                name="date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <>
                    <Form.Control {...field} type="date" />
                    {errors.date && (
                      <div className="invalid-feedback d-block">
                        This field is required
                      </div>
                    )}
                  </>
                )}
              />
            </Form.Group>
          </div>

          {/* Filter by Driver */}
          <div className="col-lg-4">
            <Form.Group className="mb-0">
              <Form.Label>Filter by Driver: </Form.Label>
              <Controller
                name="driver"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Form.Select {...field}>
                    <option value="">Select Driver</option>
                    {drivers.map((d) => (
                      <option key={d.id} value={d.name}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              />
            </Form.Group>
          </div>

          {/* Reset Button */}
          <div className="col-lg-2 col-md-4">
            <LoadingButton
              name="Reset Filter"
              className="w-100"
              onClick={() => {
                reset({
                  date: '',
                  driver: '',
                })
                console.log('reset')
                setQuery(null)
              }}
              type="button"
            />
          </div>

          {/* Filter Button */}
          <div className="col-lg-2 col-md-4">
            <LoadingButtonWithForm
              name="Filter"
              form="filter-management"
              className="w-100"
            />
          </div>
        </Form>
      </div>
    </>
  )
}

export default Filter
